import { lessonOverviewActionTypes } from './Constants';

export function getLessonOverview(queries) {
	return {
		type: lessonOverviewActionTypes.GET_LESSON_OVERVIEW_REQUEST,
		payload: { queries },
	};
}

export function getLessonOverviewSuccess(data) {
	return {
		type: lessonOverviewActionTypes.GET_LESSON_OVERVIEW_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getLessonOverviewError(error) {
	return {
		type: lessonOverviewActionTypes.GET_LESSON_OVERVIEW_ERROR,
		payload: {
			error,
		},
	};
}

export function changeFilters(data) {
	return {
		type: lessonOverviewActionTypes.CHANGE_LESSON_OVERVIEW_FILTERS,
		payload: { data },
	};
}

export function getMyScheduledLessons(userId) {
	return {
		type: lessonOverviewActionTypes.GET_MY_SCHEDULED_LESSONS_REQUEST,
		payload: { userId },
	};
}

export function getMyScheduledLessonsSuccess(data) {
	return {
		type: lessonOverviewActionTypes.GET_MY_SCHEDULED_LESSONS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getMyScheduledLessonsError(error) {
	return {
		type: lessonOverviewActionTypes.GET_MY_SCHEDULED_LESSONS_ERROR,
		payload: {
			error,
		},
	};
}

export function getRecommendedLessons(queries) {
	return {
		type: lessonOverviewActionTypes.GET_RECOMMENDED_LESSONS_REQUEST,
		payload: { queries },
	};
}

export function getRecommendedLessonsSuccess(data) {
	return {
		type: lessonOverviewActionTypes.GET_RECOMMENDED_LESSONS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getRecommendedLessonsError(error) {
	return {
		type: lessonOverviewActionTypes.GET_RECOMMENDED_LESSONS_ERROR,
		payload: {
			error,
		},
	};
}
